import { Injectable, Injector } from "@angular/core";
import { Service } from "@services/service";

@Injectable()
export class MaterialService extends Service {
	constructor(injector: Injector) {
		super("Material", injector);
	}
}